<app-page-heading [key]="'hotspots.list.page-title'"></app-page-heading>

<section class="container-fluid summary-panel">

    <app-data-table [columns]="columns" [sortColumn]="sortColumn" [direction]="direction" [loadPage]="loadPage" [(filters)]="filters" [filtersComponent]="dataFilters" (onLoad)="pageLoaded()">
        <app-data-filters #dataFilters>
            <app-data-filter-group>
                <app-data-filter-input [labelKey]="'hotspots.list.filters.label.label'"
                                       [placeholderKey]="'hotspots.list.filters.label.placeholder'"
                                       [(model)]="filters.label">
                </app-data-filter-input>

                <app-data-filter-select [labelKey]="'hotspots.list.filters.type.label'" [(model)]="filters.type"
                                              [options]="typesOptions"></app-data-filter-select>

                <app-data-filter-input [labelKey]="'hotspots.list.filters.latitude.label'"
                                       [placeholderKey]="'hotspots.list.filters.latitude.placeholder'"
                                       [(model)]="filters.latitude" [isNumber]="true" [min]="-90" [max]="90" [step]="0.000001">
                </app-data-filter-input>

                <app-data-filter-input [labelKey]="'hotspots.list.filters.longitude.label'"
                                       [placeholderKey]="'hotspots.list.filters.longitude.placeholder'"
                                       [(model)]="filters.longitude" [isNumber]="true" [min]="-180" [max]="180" [step]="0.000001">
                </app-data-filter-input>

                <app-data-filter-input [labelKey]="'hotspots.list.filters.radius.label'"
                                       [placeholderKey]="'hotspots.list.filters.radius.placeholder'"
                                       [(model)]="filters.radius" [isNumber]="true" [min]="1" [max]="10000" [step]="10">

                </app-data-filter-input>
            </app-data-filter-group>
        </app-data-filters>
    </app-data-table>
</section>


<ng-template #labelColumn let-label="label">
    <span *ngIf="label">{{label}}</span>
    <i *ngIf="!label" class="no-description" [i18n]="[{target: 'innerHTML', key: 'hotspots.list.table.label-empty'}]">No description yet</i>
</ng-template>

<ng-template #positionColumn let-latitude="latitude" let-longitude="longitude">
    {{latitude}}, {{longitude}}
</ng-template>

<ng-template #radiusColumn let-radius="radius">
    {{radius}}
</ng-template>

<ng-template #typeColumn let-type="type">
    <app-hotspot-type-icon [type]="type"></app-hotspot-type-icon>
</ng-template>

<ng-template #addressColumn let-address="address">
    {{address}}
</ng-template>

<ng-template #countryColumn let-country="country" let-countryCode="countryCode">
    <span *ngIf="country">{{country}} ({{countryCode}})</span>
</ng-template>

<ng-template #actionsColumn let-id="id">
    <button class="btn btn-outline-secondary btn-sm" (click)="goToHotspot(id)"><i class="fa fa-edit"></i></button>
</ng-template>
